"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warnIfPreviewOnOptions = warnIfPreviewOnOptions;
exports.warnIfPreviewHasFields = warnIfPreviewHasFields;

function warnIfPreviewOnOptions(type) {
  if (type.options && type.options.preview) {
    // eslint-disable-next-line no-console
    console.warn("Heads up! The preview config is no longer defined on \"options\", but instead on the type/field itself.\nPlease move {options: {preview: ...}} to {..., preview: ...} on the type/field definition of \"".concat(type.name, "\".\n"));
  }
}

function warnIfPreviewHasFields(type) {
  var preview = type.preview || (type.options || {}).preview;

  if (preview && 'fields' in preview) {
    // eslint-disable-next-line no-console
    console.warn("Heads up! \"preview.fields\" should be renamed to \"preview.select\". Please update the preview config for \"".concat(type.name, "\".\n"));
  }
}